import SecurityPage from "@features/security/components/SecurityPage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Shield } from "lucide-react";

/**
 * Security Module Route
 *
 * Parent route for the security admin section (Users, Profiles, Permissions).
 * Guarded by security.users.view — the broadest security permission.
 * Child routes enforce finer-grained permissions per feature.
 */
export const Route = createFileRoute("/_app/admin")({
  loader: requirePermission(PERMISSIONS.SECURITY.USERS.VIEW, {
    redirectTo: "/unauthorized",
  }),
  staticData: {
    title: "Securite",
    icon: Shield,
    permission: PERMISSIONS.SECURITY.USERS.VIEW,
    module: "security",
    section: "Administration",
    order: 90,
    showInNav: true,
  },
  component: SecurityPage,
});
